import { withInstall } from '@ll-plus/utils'

import NumberRange from './src/number-range.vue'

export const LlNumberRange = withInstall(NumberRange)

export default LlNumberRange

export * from './src/number-range'

declare module 'vue' {
  export interface GlobalComponents {
    LlNumberRange: typeof NumberRange
  }
}
